// ═══════════════════════════════════════════════════
// DashboardLayout — The shell that holds it all
// Sidebar + Topbar + Content area + Error boundary
// ═══════════════════════════════════════════════════

import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useUIStore } from '@/stores/ui';
import styles from './DashboardLayout.module.css';

function PageLoader() {
  return (
    <div className={styles.loader}>
      <div className={styles.loaderPulse}>
        <div className={styles.loaderDot} />
        <div className={styles.loaderDot} style={{ animationDelay: '0.15s' }} />
        <div className={styles.loaderDot} style={{ animationDelay: '0.3s' }} />
      </div>
      <p className={styles.loaderText}>Loading your compliance data...</p>
    </div>
  );
}

export function DashboardLayout() {
  const collapsed = useUIStore((s) => s.sidebarCollapsed);

  return (
    <div className={styles.layout}>
      <Sidebar />
      <Topbar />

      <main
        className={styles.content}
        style={{
          marginLeft: collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)',
        }}
        id="main-content"
      >
        <ErrorBoundary level="route">
          <Suspense fallback={<PageLoader />}>
            <div className={styles.contentInner}>
              <Outlet />
              <footer className={styles.dashFooter}>
                <p className={styles.disclaimer}>Proppulse is a digital intelligence platform, not a law firm. Findings are starting points for investigation, not legal determinations. Always consult a qualified Fair Housing attorney.</p>
                <p className={styles.copyright}>&copy; 2026 Proppulse.ai</p>
              </footer>
            </div>
          </Suspense>
        </ErrorBoundary>
      </main>
    </div>
  );
}

